import React from 'react';

import AKTranslateIcon from '@atlaskit/icon/core/translate';

export const TranslateIcon = (): React.JSX.Element => (
	<AKTranslateIcon label="" color="currentColor" spacing="spacious" />
);
